module.exports = __webpack_public_path__ + "static/media/bursts_26.dbf997d3.svg";